<template>
    <section id="our-difference" class="bg-bottom pt-md-5 pb-md-5 pt-3 pb-3">
        <div class="container">
            <h2>The Empower Direct <span>difference</span></h2>

            <p>
                We’re bi-coastal, global, and multilingual, which means our team is managing your account 365, 24/7.<br>
                Real time updates mean real results for your business.
            </p>

            <div class="map">
                <figure>
                    <img src="../assets/world-map.svg" alt="">
                </figure>
                <div class="tag tag-1"></div>
                <div class="tag tag-2"></div>
                <div class="tag tag-3"></div>
                <div class="tag tag-4"></div>
            </div>
            <div class="map-mini">
                <figure>
                    <img src="../assets/world-map-with-tags.png" alt="">
                </figure>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'OurDifference',
    };
</script>

<style lang="scss">
    #our-difference {
        p {
            text-align: center;
            margin-bottom: 3rem;
        }
        .map {
            position: relative;
            .tag {
                position: absolute;
                width: 40px;
                height: 52px;
                background: url('../assets/tag-map.svg') no-repeat;
            }
            @media (min-width: 576px) {
                .tag-1 {
                    top: 18px;
                    left: 58px;
                }
                .tag-2 {
                    top: 76px;
                    left: 71px;
                }
                .tag-3 {
                    top: 0;
                    left: 245px;
                }
                .tag-4 {
                    top: 5px;
                    left: 228px;
                }
            }
            @media (min-width: 768px) {
                .tag-1 {
                    top: 43px;
                    left: 83px;
                }
                .tag-2 {
                    top: 120px;
                    left: 102px;
                }
                .tag-3 {
                    top: 20px;
                    left: 337px;
                }
                .tag-4 {
                    top: 23px;
                    left: 315px;
                }
            }
            @media (min-width: 992px) {
                .tag-1 {
                    top: 80px;
                    left: 120px;
                }
                .tag-2 {
                    top: 180px;
                    left: 144px;
                }
                .tag-3 {
                    top: 45px;
                    left: 465px;
                }
                .tag-4 {
                    top: 52px;
                    left: 431px;
                }
            }
            @media (min-width: 1200px) {
                .tag-1 {
                    top: 100px;
                    left: 145px;
                }
                .tag-2 {
                    top: 221px;
                    left: 175px;
                }
                .tag-3 {
                    top: 63px;
                    left: 555px;
                }
                .tag-4 {
                    top: 77px;
                    left: 516px;
                }
            }
        }
        @media (min-width: 576px) {
            .map-mini {
                display: none;
            }
        }
        @media (max-width: 575px) {
            .map {
                display: none;
            }
            .map-mini {
                display: block;
            }
        }
    }
</style>
